import { useQuery } from '@tanstack/react-query';

import { AccountsApi } from '../../apis';
import { AccountsFilter, AccountStatus } from '../../models/accounts';
import { QueryKeys } from '../query-keys';

const useAccounts = (
  filter: AccountsFilter = { status: AccountStatus.ACTIVE },
  page = 1,
  perPage = 100
) => {
  const query = useQuery({
    queryKey: [QueryKeys.ACCOUNTS, filter, page, perPage],
    queryFn: () => AccountsApi.getPage({ filter, page, perPage }),
  });

  return {
    isLoading: query.isPending,
    hasError: query.isError,
    page: query.data?.page || 1,
    perPage: query.data?.perPage || 10,
    total: query.data?.total || 0,
    totalPages: query.data?.totalPages || 0,
    accounts: query.data?.accounts || [],
    filter,
  };
};

export default useAccounts;
